import React from 'react';

const EntradaMaterialFilterBar = ({ filters, onChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 mb-4 w-full max-w-full">
      <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 w-full">
        <input
          type="date"
          name="dataEntrada"
          placeholder="Data de Entrada"
          value={filters.dataEntrada}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        />
        <select
          name="tipo"
          value={filters.tipo}
          onChange={onChange}
          className="w-full px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400 min-w-0"
        >
          <option value="">Todos os Tipos</option>
          <option value="Normal">Normal</option>
          <option value="Troca">Troca</option>
          <option value="Devolução">Devolução</option>
        </select>
      </div>
    </div>
  );
};

export default EntradaMaterialFilterBar;
